import { eventDataHelpers } from "global/cnr/reducers/reducerHelpers/eventDataHelpers";
import { convertGsToHtml, convertHelpers, createStaticViewFromDataCollections } from "global/common/convert";
import { ammendAllDates } from "global/common/dateFormatting";
import { recreateDataHelpers } from "global/firestoreData/appData/fsRecreateData";
import { updateLinkHelpers } from "global/firestoreData/updates/subUpdates/fsUpdate_dataLInks";
import { fsfn_sheets } from "global/functions/fbSheetsFuntions";
import { useCallback, useContext, useMemo } from "react";
import { AppContext } from "../AppProvider";
import { fsCallAll } from "../contextHelpers/fcCalls";
import { DatabaseContext } from "../DatabaseContext";
import { ParentContext } from "../ParentContext";
import { useAppUserAccess } from "./useAppUserAccess";

const _showCallLogs = true;

export const useGoogleSheets = () => {

  const appUserAccess = useAppUserAccess()
  const { email: authEmail } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext)
  const { states, fn_cls } = parentContext ?? {}
  const { eventInfo_state, paps_state, currentSettings_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const { appDataDocuments } = eventInfo_state ?? {}

  const { gvviSettings } = currentSettings_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});

  const { googleSheets, googleSheetsImportOptions } = aps_global ?? {}
  const { googleSheetsId } = googleSheets ?? {}

  const { database_fns } = useContext(DatabaseContext) ?? {};
  const { app_state } = useContext(AppContext);

  const { mainFunctions, app_alts, app_prods, mainStorage } = app_state ?? {};
  const { altFunctions } = app_alts ?? {};
  const { prodFunctions } = app_prods ?? {};

  const allFunctions = useMemo(
    () => ({ mainFunctions, altFunctions, prodFunctions }),
    [mainFunctions, altFunctions, prodFunctions]
  );

  const fsCall = async (genericType, callData) => {
    return fsCallAll(mainFunctions, genericType, callData, allFunctions, _showCallLogs);
  };

  const getDataFromGoogleSheets = useCallback(async ({ gsId, callback, fromCreate, forDemo }) => {
    const cb = (gsResponse) => callback(gsResponse)
    const { aps_viewItems } = gvviSettings
    const formData = { googleSheetsId: gsId || googleSheetsId }
    const sheetProps = { formData, pathViews }
    const sheetOpts = {
      appArea: 'event',
      googleSheetsImportOptions,
      logging: null,
      appDataDocuments,
      staticViews_app: appDataDocuments,
      forDataManagement: true,
      aps_viewItems,
      forDemo,
      authEmail,
      forceEmailAuth: false,
      createViews: true,
    }
    const response = await fn_cls.createProjectFromSheets(sheetProps, sheetOpts)
    const { success, result } = response ?? {}
    const _result = _.cloneDeep(result)
    const opts = { authEmail, fromCreate: fromCreate, pathViews, googleSheetsImportOptions, appDataDocuments, staticViews_app: appDataDocuments, gvviSettings }
    const _opts = { ...opts, fromCreate, forDemo }
    if (success) {
      ammendDataFromGoogleSheets(result, _result, _opts, cb)
    } else {
      cb({ success: false })
    }
  }, [])

  const getGoggleSheetSimple = useCallback(async ({ gsId, sheetName }) => {
    const cbgs = () => { }
    const cbgse = (de) => {
      console.log('de', de)
    }
    fn_cls.getGoogleSheetSimple(gsId, sheetName, cbgs, cbgse)
  }, [])

  const functions_fns = useMemo(() => ({
    fc_sheets: fsfn_sheets(fsCall, database_fns),
    recreateDataHelpers: recreateDataHelpers,

  }), [fsCall, database_fns, mainStorage]);

  return { functions_fns, getDataFromGoogleSheets, getGoggleSheetSimple }

}

const ammendDataFromGoogleSheets = async (result_fromGoogle, _result_fromGoogle, opts, callback, googleSheetItems) => {

  // appDataDocuments does NOT have doc keys

  const { projectData, projectSettings: projectSettings_gs, appDataLinks, _newCounts } = result_fromGoogle ?? {}
  const { viewItems, views } = projectSettings_gs ?? {}
  const { gvviSettings, fromCreate, forDemo } = opts ?? {}
  const { aps_viewItems, aps_views } = gvviSettings ?? {}

  const _excluded = googleSheetItems ? _.filter(googleSheetItems, { included: false }) : []
  const excludedItemKeys = _excluded.map(item => item.key);

  if (excludedItemKeys.length > 0) {
    removeExcludedItems(viewItems, excludedItemKeys)
    removeExcludedItems(views, excludedItemKeys, true)
    removeExcludedItems(aps_viewItems, excludedItemKeys)
    removeExcludedItems(aps_views, excludedItemKeys)
    removeExcludedItems(aps_views, excludedItemKeys, true)
  }

  const { dataCollections } = projectData ?? {}
  // dataCollections has doc keys!!

  const svs = createStaticViewFromDataCollections(dataCollections, aps_viewItems)
  if (dataCollections) { ammendAllDates(dataCollections, true) }
  convertGsToHtml(dataCollections)

  const {
    previewSettings: _projectSettings,
    previewSettings_gs_app: previewSettings_gs_app,
    previewSettings_app_gs: previewSettings_app_gs
  } = eventDataHelpers.getPreviewSettings(projectSettings_gs, gvviSettings, fromCreate)

  const _appDataDocuments = convertHelpers.createDocumentData(dataCollections)
  const _appDataLinks = updateLinkHelpers.createAppLinks(null, dataCollections)

  const _preview = {
    projectData: projectData,
    projectSettings: _projectSettings,
    appDataDocuments: _appDataDocuments,
    appDataLinks: _appDataLinks, // generated from dataCollections
  }

  const _preview_alt = {
    projectSettings_gs,
    previewSettings_gs_app: previewSettings_gs_app,
    previewSettings_app_gs: previewSettings_app_gs,
    appDataLinks_gs: appDataLinks,
    _newCounts: _newCounts,
  }

  callback({ success: true, _preview, _preview_alt, svs, dcs: dataCollections, result_fromGoogle: _result_fromGoogle, forDemo })
}

const removeExcludedItems = (items, excludedItemKeys, includeList) => {
  if (items && excludedItemKeys) {
    Object.keys(items).forEach(vik => {
      const _vik = includeList ? vik.replace('_list', '') : vik
      if (excludedItemKeys.includes(_vik)) {
        delete items[vik]
      }
    })
  }
}


